import { hasOwnProperty } from 'shared/lib'

const toSnakeCase = (str: string): string =>
  str.replace(/([A-Z])/g, '_$1').toLowerCase()

export const keysToSnakeCase = (obj: any): any => {
  if (Array.isArray(obj)) {
    return obj.map(keysToSnakeCase)
  } else if (
    obj !== null &&
    typeof obj === 'object' &&
    !(obj instanceof File)
  ) {
    const newObj: Record<string, any> = {}

    for (const key in obj) {
      if (hasOwnProperty(obj, key)) {
        const snakeKey = toSnakeCase(key)

        newObj[snakeKey] = keysToSnakeCase(obj[key])
      }
    }

    return newObj
  }

  return obj
}
